import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType, SlotsType } from 'vue'


export const edittableColumnButtongroupProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
})

export type EdittableColumnButtongroupProps = Partial<ExtractPropTypes<ReturnType<typeof edittableColumnButtongroupProps>>>

export default defineComponent({
  name: 'OEdittableColumnButtongroup',
  inheritAttrs: false,
  props: edittableColumnButtongroupProps(),
  slots: Object as SlotsType<{
    default: any
  }>,
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
